var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8046_6379)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8046_6379",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H0V12H12V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8046_6379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75653 9.28413C7.38349 9.28413 9.51306 7.20581 9.51306 4.64207C9.51306 2.07832 7.38349 0 4.75653 0C2.12957 0 0 2.07832 0 4.64207C0 7.20581 2.12957 9.28413 4.75653 9.28413Z",
    fill: "url(#paint0_linear_8046_6379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94385 8.99365L10.9999 11.0001",
    stroke: "url(#paint1_linear_8046_6379)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8046_6379",
    x1: 4.75653,
    y1: 0,
    x2: 4.75653,
    y2: 9.28413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8046_6379",
    x1: 9.97187,
    y1: 8.99365,
    x2: 9.97187,
    y2: 11.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8046_6379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSearch);
export default __webpack_public_path__ + "static/media/Menu-Search.383b95ae76654a77fcfbae7528dfa0f5.svg";
export { ForwardRef as ReactComponent };